import { ProgramType, ProgramVisibility } from "@modules/programs/types/programTypes"
import { z } from "zod"

export const CreateUserProgramInputDtoSchema = z
  .object({
    name: z.string().min(0).max(255),
    description: z.string().min(0).max(65535),
    imageKey: z.string().nullable(), // S3 key of the image
    visibility: z.enum(ProgramVisibility),
    entranceCheckEnabled: z.boolean(),
    defaultHideSessionContent: z.boolean().nullable(),
    scoreboardVisibility: z.boolean(),
    sharedCoaches: z.array(z.string()).nullable(),
    type: z.enum(ProgramType),
    duration: z.number().nullable(),
    programIdToDuplicate: z.string().nullable(),
  })
  .meta({ id: "CreateUserProgramInputDtoSchema" })

export const UpdateUserProgramInputDtoSchema = z
  .object({
    name: z.string().min(0).max(255),
    description: z.string().min(0).max(65535),
    imageKey: z.string().nullable(), // S3 key of the image
    visibility: z.enum(ProgramVisibility),
    entranceCheckEnabled: z.boolean(),
    defaultHideSessionContent: z.boolean().nullable(),
    scoreboardVisibility: z.boolean(),
    sharedCoaches: z.array(z.string()).nullable(),
    duration: z.number().nullable(),
  })
  .meta({ id: "UpdateUserProgramInputDtoSchema" })

export type CreateUserProgramInputDto = z.infer<typeof CreateUserProgramInputDtoSchema>
export type UpdateUserProgramInputDto = z.infer<typeof UpdateUserProgramInputDtoSchema>
